angular.module('picmonicng').controller('AppController', [
  '$http',
  '$rootScope',
  '$scope',
  '$state',
  'Navigation',
  'Modal',
  'PlaylistService',
  'LearnService',
  'EditorService',
  'UserService',
  'BrowseService',
  '$modal',
  '$cookies',
  function (
    $http,
    $rootScope,
    $scope,
    $state,
    Navigation,
    Modal,
    PlaylistService,
    LearnService,
    EditorService,
    UserService,
    BrowseService,
    $modal,
    $cookies
  ) {
    $scope.$rootScope = $rootScope;
    $scope.PlaylistService = PlaylistService;
    $scope.Navigation = Navigation;
    $scope.BrowseService = BrowseService;
    $scope.Modal = Modal;
    $scope.EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i;
    if (bowser.parsedResult.browser.name === 'Safari') {
      $rootScope.htmlClasses.push('safari');
    }

    $scope.UserService = UserService;

    $rootScope.$on('$viewContentLoaded', function (event, toState) {
      var stateName = $state.current.name ? $state.current.name.split('.')[1] : location.pathname.split('/')[1];

      $scope.bodyClass = [stateName];
    });

    var stateName = $state.current.name ? $state.current.name.split('.')[1] : location.pathname.split('/')[1];
    $scope.bodyClass = [stateName];

    /*//used when we need to pop up alert for maintanence
        if (!$cookies.get('pls_app_alert_seen') || $cookies.get('pls_app_alert_seen') < 1473909049053) {
            $modal.open({
                templateUrl: '/templates/modals/app-alert.html',
                backdrop: true,
                controller: ['$scope', function ($scope) {
                }]
            });
            $cookies.put('pls_app_alert_seen', Date.now());
        }*/
  },
]);
